import Button from 'components/Button'
import Flex from 'components/Flex'
import JPGIcon from 'components/icons/JPGIcon'
import PDFIcon from 'components/icons/PDFIcon'
import Visibility from 'components/icons/Visibility'
import * as FileSaver from 'file-saver'
import moment from 'moment'
import React from 'react'
import {
  AdjustIcon,
  SmallCirlcle,
  SpanText,
  StyledCardDiv,
  StyledH2,
  StyledImg,
  StyledP,
  VisibleDiv,
} from '../../components/Uploader/Style'

const FileReaderVisible = ({ file, setFile, doc, DocumentsDetails }) => {
  let size = (doc?.size / 1024 / 1024)?.toFixed(2) + ' MB'

  const viewFile = () => {
    const newWindow = window?.open(doc?.url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const downloadPDF = () => {
    const fileUrl = doc?.url
    const xhr = new XMLHttpRequest()
    xhr.open('GET', fileUrl, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], {
          type: 'application/' + doc?.type,
        })
        FileSaver.saveAs(blob, doc?.name)
      }
    }

    xhr.send()
  }

  return (
    <StyledCardDiv spaceBetween center alignCenter>
      <StyledImg>
        <AdjustIcon margin>
          {doc?.type === 'pdf' ? <PDFIcon /> : <JPGIcon />}
        </AdjustIcon>
        <Flex column>
          <StyledH2>{doc?.name}</StyledH2>
          <StyledP alignCenter>
            <SpanText>
              {moment(doc?.date)?.format('Do MMM, YYYY') +
                ' at ' +
                moment(doc?.date)?.format('h:mm')}
            </SpanText>
            <SmallCirlcle />
            <SpanText>{size}</SpanText>
          </StyledP>
        </Flex>
      </StyledImg>

      <Flex alignCenter>
        <Button.Secondary
          height="38px"
          text="Download"
          htmlType="submit"
          onClick={downloadPDF}
        />
        <VisibleDiv onClick={() => viewFile()}>
          <Visibility />
        </VisibleDiv>
      </Flex>
    </StyledCardDiv>
  )
}

export default FileReaderVisible
